import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, Fragment as _Fragment, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "condition-summary" }
const _hoisted_2 = ["aria-label"]
const _hoisted_3 = {
  class: "mode-tabs",
  role: "group",
  "aria-label": "条件编辑模式"
}
const _hoisted_4 = ["aria-pressed"]
const _hoisted_5 = ["aria-pressed"]
const _hoisted_6 = {
  key: 0,
  class: "notice",
  role: "status"
}
const _hoisted_7 = {
  key: 0,
  class: "error",
  role: "alert"
}
const _hoisted_8 = {
  key: 1,
  class: "expression-preview"
}
const _hoisted_9 = { class: "source-field" }
const _hoisted_10 = ["disabled"]

import { computed, ref } from "vue";
import { NModal } from "naive-ui";
import { createConditionGroup, type VisualCondition } from "../types/VisualCondition";
import { parseVisualCondition, serializeVisualCondition } from "../utils/visualCondition";
import ConditionTreeEditor from "./ConditionTreeEditor.vue";

export default /*@__PURE__*/_defineComponent({
  __name: 'VisualConditionEditor',
  props: {
    modelValue: {},
    label: {}
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const emit = __emit;
const show = ref(false);
const mode = ref<"visual" | "source">("visual");
const draft = ref<VisualCondition>(createConditionGroup());
const source = ref("");
const original = ref("");
const notice = ref("");
const generated = computed(() => {
  try { return { text: serializeVisualCondition(draft.value), error: "" }; }
  catch (error) { return { text: "", error: error instanceof Error ? error.message : "条件配置不完整。" }; }
});
function open() {
  source.value = original.value = props.modelValue;
  const parsed = parseVisualCondition(source.value);
  draft.value = parsed ?? createConditionGroup();
  mode.value = !source.value.trim() || parsed ? "visual" : "source";
  notice.value = mode.value === "source" ? "这条表达式包含可视化编辑暂不支持的语法，原文已保留，可继续编辑原文。" : "";
  show.value = true;
}
function changeMode(next: "visual" | "source") {
  if (mode.value === next) return;
  if (next === "source") {
    if (generated.value.error) { notice.value = generated.value.error; return; }
    source.value = generated.value.text;
  } else {
    const parsed = parseVisualCondition(source.value);
    if (source.value.trim() && !parsed) { notice.value = "当前原文无法转换。可以继续编辑原文，或点击“重新搭建条件”替换草稿。"; return; }
    draft.value = parsed ?? createConditionGroup();
  }
  notice.value = ""; mode.value = next;
}
function rebuild() { draft.value = createConditionGroup(); mode.value = "visual"; notice.value = "正在重新搭建，点击保存后才会替换原条件；取消可保留原文。"; }
function save() {
  if (props.modelValue !== original.value) { notice.value = "原条件已在其他位置更新，请关闭后重新打开，避免覆盖。"; return; }
  if (mode.value === "visual" && generated.value.error) return;
  emit("update:modelValue", mode.value === "visual" ? generated.value.text : source.value);
  show.value = false;
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("span", null, _toDisplayString(__props.modelValue || '尚未设置条件'), 1),
      _createElementVNode("button", {
        type: "button",
        "aria-label": `编辑${__props.label}条件`,
        onClick: _withModifiers(open, ["stop"])
      }, "编辑条件", 8, _hoisted_2)
    ]),
    _createVNode(_unref(NModal), {
      show: show.value,
      "onUpdate:show": _cache[11] || (_cache[11] = ($event: any) => ((show).value = $event)),
      preset: "card",
      class: "condition-editor-modal dsfg-typography",
      title: `${__props.label} · 条件编辑`,
      style: { width: 'min(900px, calc(100vw - 32px))', maxHeight: 'calc(100dvh - 48px)', borderRadius: '14px' },
      "header-style": { flexShrink: '0', padding: '18px 20px', fontSize: '16px', fontWeight: '600', color: '#33476b' },
      "content-style": { minHeight: '0', overflowY: 'auto', padding: '0 20px 18px' },
      "footer-style": { flexShrink: '0', padding: '14px 20px', borderTop: '1px solid #d8deec' },
      "mask-closable": false
    }, {
      footer: _withCtx(() => [
        _createElementVNode("footer", {
          class: "condition-editor-actions",
          onKeydown: _cache[8] || (_cache[8] = _withModifiers(() => {}, ["stop"])),
          onKeyup: _cache[9] || (_cache[9] = _withModifiers(() => {}, ["stop"])),
          onPointerdown: _cache[10] || (_cache[10] = _withModifiers(() => {}, ["stop"]))
        }, [
          _createElementVNode("button", {
            type: "button",
            onClick: _cache[7] || (_cache[7] = ($event: any) => (show.value = false))
          }, "取消"),
          _createElementVNode("button", {
            class: "save",
            type: "button",
            disabled: mode.value === 'visual' && !!generated.value.error,
            onClick: save
          }, "保存条件", 8, _hoisted_10)
        ], 32)
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", {
          class: "visual-condition-editor",
          onKeydown: _cache[4] || (_cache[4] = _withModifiers(() => {}, ["stop"])),
          onKeyup: _cache[5] || (_cache[5] = _withModifiers(() => {}, ["stop"])),
          onPointerdown: _cache[6] || (_cache[6] = _withModifiers(() => {}, ["stop"]))
        }, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("button", {
              type: "button",
              "aria-pressed": mode.value === 'visual',
              onClick: _cache[0] || (_cache[0] = ($event: any) => (changeMode('visual')))
            }, "可视化条件", 8, _hoisted_4),
            _createElementVNode("button", {
              type: "button",
              "aria-pressed": mode.value === 'source',
              onClick: _cache[1] || (_cache[1] = ($event: any) => (changeMode('source')))
            }, "表达式原文", 8, _hoisted_5)
          ]),
          _cache[15] || (_cache[15] = _createElementVNode("details", { class: "condition-help" }, [
            _createElementVNode("summary", null, "条件与变量填写说明"),
            _createElementVNode("p", { class: "hint" }, "左值与右值都可选择变量或固定值。“且”要求全部满足，“或”要求任一满足；括号组内先组合，再与外层组合。"),
            _createElementVNode("p", { class: "hint" }, "玩家与角色指当前客户端自身。变量路径支持“背包.金币”“奖励.1.数量”，列表从 1 开始。")
          ], -1)),
          (notice.value)
            ? (_openBlock(), _createElementBlock("p", _hoisted_6, _toDisplayString(notice.value), 1))
            : _createCommentVNode("", true),
          (mode.value === 'visual')
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _createVNode(ConditionTreeEditor, {
                  modelValue: draft.value,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((draft).value = $event))
                }, null, 8, ["modelValue"]),
                (generated.value.error)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_7, _toDisplayString(generated.value.error), 1))
                  : (_openBlock(), _createElementBlock("details", _hoisted_8, [
                      _cache[12] || (_cache[12] = _createElementVNode("summary", null, "生成的表达式", -1)),
                      _createElementVNode("pre", null, _toDisplayString(generated.value.text), 1)
                    ]))
              ], 64))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                _createElementVNode("label", _hoisted_9, [
                  _cache[13] || (_cache[13] = _createTextVNode("表达式原文", -1)),
                  _withDirectives(_createElementVNode("textarea", {
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((source).value = $event)),
                    "aria-label": "条件表达式原文",
                    rows: "6",
                    spellcheck: "false"
                  }, null, 512), [
                    [_vModelText, source.value]
                  ])
                ]),
                _cache[14] || (_cache[14] = _createElementVNode("p", { class: "hint" }, "原文按输入保存，不在网页中执行；复杂运算、逻辑非和动态变量路径可在这里保留。", -1)),
                _createElementVNode("button", {
                  type: "button",
                  onClick: rebuild
                }, "重新搭建条件")
              ], 64))
        ], 32)
      ]),
      _: 1
    }, 8, ["show", "title"])
  ], 64))
}
}

})